import { defineStore } from "pinia";
import { computed, reactive } from "vue";
export type GlobalMessage = {
    type: "error" | "warning" | "info" | "success";
    message: string;
};

type State = {
    messages: GlobalMessage[];
};

export const useGlobalMessagesStore = defineStore("global-messages", () => {
    const state = reactive<State>({
        messages: [],
    });
    const messages = computed(() => state.messages);

    const push = (message: GlobalMessage | GlobalMessage[]) => {
        if (Array.isArray(message)) {
            state.messages.push(...message);
        }
        else {
            state.messages.push(message);
        }
    };

    const clear = () => {
        state.messages = [];
    };

    const deleteByIndex = (index: number) => {
        const toDelete = state.messages[index];

        if (!toDelete) {
            return;
        }

        state.messages.splice(index, 1);
    };

    const deleteByReference = (message: GlobalMessage) => {
        const indexToDelete = state.messages.indexOf(message);

        if (indexToDelete < 0) {
            return;
        }

        state.messages.splice(indexToDelete, 1);
    };

    return { messages, push, clear, deleteByIndex, deleteByReference };
});
